<script setup lang="ts">
/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const imageContainerRef = ref<HTMLElement | null>(null)
const windowsWidth = ref(import.meta.client ? window.innerWidth : 1024)
const props = defineProps<{
    bannersImage: any
}>()

/**
 *
 *  Life cicle events
 *
 *
 */

const counter = ref(0)

watch(
    () => props.bannersImage,
    () => {
        if (!import.meta.client) return
        const balls = document.querySelectorAll(".home-carousel-indicator-item")
        if (counter.value == 0) {
            balls[0]?.classList.remove("active")
            balls[1]?.classList.add("active")
            balls[2]?.classList.remove("active")
        } else if (counter.value == 1) {
            balls[0]?.classList.remove("active")
            balls[1]?.classList.remove("active")
            balls[2]?.classList.add("active")
        } else {
            balls[0]?.classList.add("active")
            balls[1]?.classList.remove("active")
            balls[2]?.classList.remove("active")
        }
        counter.value = counter.value + 1
        if (counter.value > 2) {
            counter.value = 0
        }
    }
)

onMounted(() => {
    window.addEventListener("resize", resize)
})
onBeforeUnmount(() => {
    window.removeEventListener("resize", resize)
})

/**
 *
 *  Functions section
 *
 *
 */

const resize = () => {
    windowsWidth.value = window.innerWidth
}
</script>

<template>
    <div class="tw-relative home-carousel-slider-container">
        <slot name="indicator-item-container">
            <div class="home-carousel-slider-indicator">
                <slot name="indicator-items">
                    <div class="home-carousel-indicator-item active"></div>
                    <div class="home-carousel-indicator-item"></div>
                    <div class="home-carousel-indicator-item"></div>
                </slot>
            </div>
        </slot>
        <div class="home-carousel-slider">
            <div class="home-carousel-slider-col">
                <div class="home-carousel-slider-stack" ref="imageContainerRef">
                    <q-skeleton
                        v-if="!props.bannersImage"
                        square
                        width="840px"
                        height="500px"
                        class="tw-w-full"
                    />
                    <q-img
                        v-if="props.bannersImage"
                        :src="
                            windowsWidth < 744 &&
                            props.bannersImage?.mobile_image
                                ? props.bannersImage?.mobile_image
                                : props.bannersImage?.image
                        "
                        width="840"
                        height="500"
                        class="tw-object-contain lg:tw-object-cover tw-object-center tw-w-full lg:tw-h-[500px]"
                        alt="banner dinámico"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
:root {
    --images-count: 3;
    --i: 0;
}

.home-carousel-slider-indicator {
    @apply tw-absolute tw-bottom-10 -tw-left-10 tw-z-10 tw-flex tw-flex-col tw-items-center tw-gap-4;
}

.home-carousel-indicator-item {
    @apply tw-w-4 tw-h-4 tw-rounded-full tw-border tw-border-white tw-z-20 tw-bg-transparent;
}

@keyframes slideUp {
    0% {
        transform: translateY(0%);
    }

    100% {
        transform: translateY(-100%);
    }
}

.home-carousel-indicator-item.active {
    background: white;
}

.home-carousel-slider {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.home-carousel-slider-col {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.home-carousel-slider-stack {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation: slideUp calc(4s * var(--images-count)) infinite
        steps(var(--images-count));
}
</style>
